// Polyfill Event.preventDefault for IE11
if (!Event.prototype.preventDefault) {
  Event.prototype.preventDefault = function() {
    this.returnValue = false
  }
}
